<template>
  <full-width-spinner v-if="busy" />
  <ion-tabs
    v-else
    class="bridge-detail"
  >
    <ion-content>
      <ion-card>
        <ion-card-header>
          <h1>{{ title }}</h1>

          <ion-tab-bar>
            <ion-tab-button
              v-for="project in projects"
              :key="project.id"
              :tab="project.id"
            >
              {{ project.name }}
            </ion-tab-button>
          </ion-tab-bar>
        </ion-card-header>

        <ion-card-content>
          <template>
            <ion-tab
              v-for="project in projects"
              :key="project.id"
              :tab="project.id"
            >
              <slot :project="project" />
            </ion-tab>
          </template>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import { alertController, modalController } from '@modus/ionic-vue'

import FullWidthSpinner from '../common/FullWidthSpinner'

export default {
  components: {
    FullWidthSpinner
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      busy: true,
    }
  },
  computed: {
    ...mapGetters([
      'projects'
    ])
  },
  created() {
    const serialNumber = this.serialNumber

    this.$store.dispatch('fetchCommits', { project: 1 })
        .finally(() => this.busy = false)
  }
}
</script>

<style scoped>
.detail-page {
  height:100%;
}

.header {
  --padding-start:0;
  margin-bottom:20px;
}

ion-card-header ion-spinner {
  width:12px;
}
</style>
